export function uppercase(val) {
  return val ? val.toLocaleUpperCase() : val
}
